import Card from "components/card";
import React, { useEffect, useState, useCallback } from "react";
import UserDataTable from "./components/UsersDataTable";
import Loader from "components/Loader";
import { fetchUsersCurrentWorkspaceAPI } from "api/axios";
import { User } from "auth/AuthProvider";
import { handleAxiosAndCaughtError } from "utils";
import { useTranslation } from "react-i18next";

const Users = () => {
  const { t } = useTranslation();
  const [users, setUsers] = useState<User[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const getUsersWorkspace= useCallback(async (signal?: AbortSignal) => {
    setLoading(true);
    setError(null);
    try {
      const resp = await fetchUsersCurrentWorkspaceAPI({
        take: 999,
        skip: 0,
        handler: {},
        signal,
      });
      setUsers(resp.items);
    } catch (err: any) {
      if (signal?.aborted || err.name === "CanceledError") {
        return; // Aborted
      }
      setError(t("users.clickToRetry"));
      handleAxiosAndCaughtError(err);
    } finally {
      setLoading(false);
    }
  }, [t]);

  useEffect(() => {
    const abortController = new AbortController();
    getUsersWorkspace(abortController.signal);
    return () => abortController.abort();
  }, [getUsersWorkspace]);

  return (
    <Card extra={" relative w-full  h-[80vh] md:mt-3 mt-12 px-6 "}>
      {loading ? (
        <Loader
          txt={t("users.loadingUsers")}
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      ) : error ? (
        <div
          className="absolute left-1/2 top-1/2 flex -translate-x-1/2
        -translate-y-1/2 flex-col items-center justify-center py-10
         "
        >
          <span className="mb-4 text-red-500">{error}</span>
          <button
            className="rounded bg-brand-500 px-4 py-2 text-white transition hover:bg-brand-600"
            onClick={() =>  getUsersWorkspace()}
          >
            {t("common.retry")}
          </button>
        </div>
      ) : (
        <UserDataTable getUsersWorkspace={getUsersWorkspace} tableData={users || []} />
      )}
    </Card>
  );
};

export default Users;
